export function isTimeGreater(time1, time2) {
    console.log("ttt", time1)
    if (time1 === null) {
        const now = new Date();
        const time = now.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit', hour12: false});
        console.log("currnet Time", time)
        console.log("hour Time", time2)
        return time >= time2;
    }
    return time1 >= time2;
}

export function convertTo12HourFormat(time) {
    let [hours, minutes] = time.split(":").map(Number);
    let period = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convert 0 to 12 for AM
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")} ${period}`;
}